import {
    SET_CAROUSEL_COUNT ,SET_TOTAL_COUNT
  } from "../../actions/policy/policyActions";
  const initialState = {
    carouselCount: 0, 
    slideTotal:0,
  };

  export default function carouselReducer (state = initialState, action) {
    switch(action.type)
    {
        case SET_CAROUSEL_COUNT:                        
        return {
            ...state,
            carouselCount: action.payload
        };
        case SET_TOTAL_COUNT:
          return {
            ...state,
            slideTotal: action.payload
          };
        default:
        return state; 
    }
}